import './App.css';
import Home from './Pages/HomePage/home';

function App() {
  return (
    <Home />
  );
}

export default App
